import { withChartLayout } from 'components/common';
import LaborInterventions from 'components/features/chart/system-nursing-interventions/labor-interventions/LaborInterventions';

const LaborInterventionsPage = withChartLayout('Labor Interventions')(LaborInterventions);
export default LaborInterventionsPage;
